/**
 * True when running inside the Electron preload bridge, false in a regular browser.
 * The preload script sets window.nativeApi via contextBridge before any web-app
 * code executes, so this is reliable at module load time.
 */
export const isElectron =
  typeof window !== "undefined" &&
  (window.desktopBridge !== undefined || window.nativeApi !== undefined);

/**
 * The build-time facts that decide how a browser build admits people and which surface it is.
 * Read once here so every decision in `browserEntry.logic` sees the same values.
 */
export const browserBuildEnvironment = {
  VITE_AFAR_RESEARCH_WEB_ONLY: import.meta.env.VITE_AFAR_RESEARCH_WEB_ONLY,
  VITE_AFAR_RESEARCH_RUNTIME_WEB: import.meta.env.VITE_AFAR_RESEARCH_RUNTIME_WEB,
  VITE_AFAR_CONNECT_ORIGIN: import.meta.env.VITE_AFAR_CONNECT_ORIGIN,
};
